<template>
  <div class='check-table'>
    <div class='terms' v-if='field.termsChick || field.importExport'>
      <div class='termsLeft' v-if='field.select && field.termsChick'>
        <span><label><input type='checkbox' terms='highCheck'>公路</label></span>
        <span><label><input type='checkbox' terms='waterCheck'>水路</label></span>
        <span><label><input type='checkbox' terms='allyCheck'>水陆联运</label></span>
      </div>
      <div class='termsRight' v-if='field.importExport'>
        <span @click='download' class='pointer'>模板下载</span>
        <span style='cursor: pointer;display: inline-block;'>
          <el-upload ref='upload' class='upload-demo' :disabled='uploadDis' :action='importUrl' :auto-upload='true'
            :show-file-list='false' :data='uploadData' :http-request='uploadHttp' :on-success='planOnSuccess'
            :before-upload='beforeUpload'>
            <i class='el-icon-upload el-icon--right'>导入对账单</i>
          </el-upload>
        </span>
        <span @click='downloadOil' class='pointer'>油价联动模板下载</span>

        <span @click='exportData' class='pointer'>导出数据</span>
      </div>
    </div>
    <div class='table'>
      <table cellspacing='1' border='0' v-loading='loadTable'>
        <thead>
          <tr>
            <th v-if='field.select' class='checkbox-th' style='min-width:60px;'>
              <input type='checkbox' name='parentAll'>全选
            </th>
            <th class='null-child' style='min-width:40px;'></th>
            <th v-for='th in columnOne' :style="{ minWidth: th.width + 'px' }" :key='th.id'>
              {{ th.title }}
            </th>
          </tr>
        </thead>
        <tbody v-if='dataOne.length > 0'>
          <template v-for='(item, index) in data'>
            <tr class='parent' :key='index' :id="'row' + index" >
              <!-- 复选框 -->
              <td v-if='field.select && item[field.terms1] == 1'>
                <input type='checkbox' :disabled='item.isReconciliation == 1' :dataId='item.id' name='parent'
                  terms='high' @change="toggleRowCheck(item)">
              </td>
              <td v-else-if='field.select && item[field.terms1] == 2'>
                <input type='checkbox' :disabled='item.isReconciliation == 1' :dataId='item.id' name='parent'
                  terms='water' @change="toggleRowCheck(item)">
              </td>
              <td v-else-if='field.select && item[field.terms1] == 3'>
                <input type='checkbox' :disabled='item.isReconciliation == 1' :dataId='item.id' name='parent'
                  terms='ally' @change="toggleRowCheck(item)">
              </td>
              <td v-else-if='field.select'>
                <input type='checkbox' :disabled='item.isReconciliation == 1' :dataId='item.id' name='parent' @change="toggleRowCheck(item)">
              </td>
              <!-- <td v-else-if='!field.select' class='null-child'></td> -->
              <!-- 展开/收起 -->
              <td v-if='item[childFiled] && item[childFiled].length > 0' class='iconfont icon-xiangzuo'
                @click='unfoldRow($event)'></td>
              <td v-else class='null-child'></td>
              <td v-for='th in columnOne' :key="th.id + '-' + index" :style="rowStyle(item)">
                <overflow-tooltip v-if="th.name == 'standingBookMonth' && item.transportationTerms == 3"
                  :content="'--'"/>
                <overflow-tooltip v-else-if="th.name == 'departurePlace'" :content='item.departurePlaceType == 1 ?
                    item.departurePlace : item.departurePort' />
                <overflow-tooltip v-else-if="th.name == 'arrivePlace'" :content='item.arrivePlaceType == 1 ?
                    item.arrivePlace : item.arrivePort' />
                <overflow-tooltip v-else :content='item[th.name] | tableValueFormat(th.name)'
                  :max-width="th.width + 'px'" />
              </td>
            </tr>
            <tr v-if='item[childFiled] && item[childFiled].length > 0' :key='item.id'
              :class="'child-row' + index + ' child'">
              <td :colspan='columnOne.length + 2'>
                <table cellspacing='1' border='0'>
                  <thead>
                    <tr>
                      <!-- <th class='checkbox-th'><input type='checkbox' :name="index + 'childAll'">全选</th> -->
                      <th v-for='th in columnTwo' :style="{ minWidth: th.width + 'px' }" :key='th.id'>
                        {{ th.title }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for='(tem, dex) in item[childFiled]' :key='tem.id'>
                      <!-- <td v-if='tem[field.terms2] == 1'>
                    <input type='checkbox' :disabled='tem.isReconciliation == 1' :dataId='tem.id' :name="index + 'child'"
                      terms='high'>
                  </td>
                  <td v-else-if='tem[field.terms2] == 2'>
                    <input type='checkbox' :disabled='tem.isReconciliation == 1' :dataId='tem.id' :name="index + 'child'"
                      terms='water'>
                  </td>
                  <td v-else-if='tem[field.terms2] == 3'>
                    <input type='checkbox' :disabled='tem.isReconciliation == 1' :dataId='tem.id' :name="index + 'child'"
                      terms='ally'>
                  </td>
                  <td v-else>
                    <input type='checkbox' :disabled='tem.isReconciliation == 1' :dataId='tem.id' :name="index + 'child'">
                  </td> -->

                      <td v-for='th in columnTwo' :key="th.id + '-' + dex">
                        <overflow-tooltip v-if="th.name == 'departurePlace'" :content='tem.departurePlaceType == 1 ?
                            tem.departurePlace : tem.departurePort' />
                        <overflow-tooltip v-else-if="th.name == 'arrivePlace'" :content='tem.arrivePlaceType == 1 ?
                            tem.arrivePlace : tem.arrivePort' />
                        <overflow-tooltip v-else :content='tem[th.name] | tableValueFormat(th.name)'
                          :max-width="th.width + 'px'" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan='columnOne.length + 1'>
              <span style='line-height:60px;color: #909399;text-align:center;'>暂无数据</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <el-dialog title='提示' :visible.sync='dialogVisible' width='400px' top='35vh' :close-on-click-modal='false'>
      <div style='max-height: 40vh;text-align: left; overflow-y: auto;' v-html='message'></div>
      <div slot='footer' class='dialog-footer'>
        <el-button class='cancel-button' type='primary' size='mini' @click='dialogClose'>
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import $ from 'jquery';
import { formatDateTime } from '@/config/mUtils';
import { shippingBookMonth } from '@/service/basicfile';
import { getImport, getImportUrl } from '@/service/getIP';
import OverflowTooltip from './OverflowTooltip.vue';
import row from "element-ui/packages/row";

export default {
  name: 'checkTable',
  computed: {
    row() {
      return row
    }
  },
  components: { OverflowTooltip },
  props: {
    // 一级表头
    columnOne: {
      type: Array,
      default: () => [],
    },
    // 二级表头
    columnTwo: {
      type: Array,
      default: () => [],
    },
    // 子表格数组名
    childFiled: {
      type: String,
      default: 'dataTwo',
    },
    // 页面数据
    dataOne: {
      type: Array,
      default: () => [],
    },
    // 其他参数
    field: {
      type: Object,
      default: () => ({
        terms1: 'batch10', // 一级菜单的运输条款字段
        terms2: 'transportationTerms', // 二级菜单的运输条款字段
        termsChick: false, // 运输条款全选框是否显示
        importExport: false, // 导入导出是否显示
        select: false, // 是否显示复选框
      }),
    },
  },
  filters: {
    tableValueFormat(val, rowName) {
      if (rowName == 'prepareType') {
        switch (parseInt(val)) {
          case 1:
            return '固定';
          case 2:
            return '比例';
        }
      } else if (rowName == 'isReconciliation') {
        switch (parseInt(val)) {
          case 0:
            return '否';
          case 1:
            return '是';
          case 2:
            return '部分生成';
        }
      } else if (rowName == 'isAdd') {
        switch (parseInt(val)) {
          case 0:
            return '否';
          case 1:
            return '是';
          default:
            return '否'
        }
      } else if (rowName == 'plannedDate') {
        return val ? formatDateTime(val, 'yyyy-mm-dd') : '';
      } else if (rowName == 'dispatchDate') {
        return val ? formatDateTime(val, 'yyyy-mm-dd') : '';
      } else if (rowName == 'deliveryDate') {
        return val ? formatDateTime(val, 'yyyy-mm-dd') : '';
      } else if (rowName == 'transportationTerms') {
        switch (parseInt(val)) {
          case 1:
            return '公路';
          case 2:
            return '水路';
          case 3:
            return '水陆联运';
        }
      } else {
        return val;
      }
    },
  },
  data() {
    return {
      // 子数组名
      data: (this.dataOne.length <= 0) ? ([{ [this.childFiled]: [] }]) : (this.dataOne),
      // 复选框选中对象数组
      checkList: [],
      // 导入生成对账单 条件赛选显示
      visible: false,
      // 导入生成对账单 条件列表
      popoverheCkList: [],
      // 导入数据
      importUrl: '',
      uploadData: { mFile: '' },
      uploadDis: false,
      loadTable: false,
      dialogVisible: false,
      message: '',
    };
  },
  mounted() {
    this.uploadUrl = getImport('/platform/settlement/consignorLine/importAccountStatement');
    this.importUrl = getImportUrl('/customer/account/importRSIExcel');
    this.allTrSelect(this.data);
  },
  methods: {
    toggleRowCheck(item) {
      const index = this.checkList.length >= 0 && this.checkList.indexOf(item);
      if (index >= 0) {
        this.checkList.push(item);
      } else {
        this.checkList.splice(index, 0);
      }
    },
    rowStyle(item) {
      return this.checkList.includes(item) ? { background: 'rgb(197 226 255)' } : {};
    },
    // 所有tr的全选事件
    allTrSelect(data) {
      const that = this;
      that.allCheck('parent', '');
      // $.each(data, (index, item) => {
      //   if (item[that.childFiled]) {
      //     if (item[that.childFiled].length > 0) {
      //       that.allCheck('child', index);
      //     }
      //   }
      // });
      that.shipTerms();
    },
    // 全选事件
    allCheck(name, i) {
      const that = this;
      // 表格的全选按钮
      $(`input[name="${i}${name}All"]`)
        .on('click', function () {
          // 选中/取消所有子选项
          if (name == 'parent') {
            $(`input[name="${i}${name}"]`)
              .prop('checked', this.checked);
            // $('input[name$=\'childAll\']')
            //   .prop('checked', this.checked);
            // $('input[name$=\'child\']')
            //   .prop('checked', this.checked);
          } else {
            $(`input[name="${i}${name}"]`)
              .prop('checked', this.checked);
          }
          // 如果存在 part 样式就移除
          if ($(this)
            .is('.part')) {
            $(this)
              .removeClass('part');
          }

          if ($(this)
            .is(':checked')) { // 该全选框已被选中 $('input[terms="high"]')
            // 一级全选框
            if (name == 'parent') {
              $(this)
                .addClass('all');
              $(`input[name='${i}${name}']`)
                .addClass('all');
              // $('input[name$=\'childAll\']')
              //   .addClass('all');
              // $('input[name$=\'child\']')
              //   .addClass('all');
            }
            // 二级全选框
            else {
              $(this)
                .addClass('all');
              $(`input[name='${i}${name}']`)
                .addClass('all');
            }
          } else { // 该全选框未被选中
            if ($(this)
              .is('.all')) {
              $(this)
                .removeClass('all');
            }
            // 一级全选框
            if (name == 'parent') {
              $(this)
                .removeClass('part');
              $(`input[name='${i}${name}']`)
                .removeClass('all');
              // $('input[name$=\'childAll\']')
              //   .removeClass('all');
              // $('input[name$=\'child\']')
              //   .removeClass('all');
            } else { // 二级全选框
              $(`input[name='${i}${name}']`)
                .removeClass('all');
            }
          }
          that.showAllCheck();
          that.checkList = that.getCheck();
        });

      // 复选框子选项
      $(`input[name='${i}${name}']`)
        .on('click', function () {
          // 该子选项已被选中
          if ($(this)
            .is(':checked')) {
            $(this)
              .addClass('all');
          }
          // 该子选项未被选中
          else {
            $(this)
              .removeClass('all');
          }
          that.showAllCheck();
          that.checkList = that.getCheck();
        });
    },

    // 各全选按钮是否显示全部选中
    showAllCheck(check) {
      // 一级全选按钮是否显示全部选中
      const len = $('input[name$=\'child\']').length + $('input[name=\'parent\']').length;
      const lenCheck = $('input[name$=\'child\']:checked').length + $('input[name=\'parent\']:checked').length;
      if (lenCheck >= len) {
        if ($('input[name=\'parentAll\']')
          .is('.part')) {
          $('input[name=\'parentAll\']')
            .removeClass('part');
        }
        if (!$('input[name=\'parentAll\']')
          .is('.all')) {
          $('input[name=\'parentAll\']')
            .addClass('all');
        }
        $('input[name=\'parentAll\']')
          .prop('checked', true);
      } else if (lenCheck > 0 || (check && check.length > 0)) {
        if ($('input[name=\'parentAll\']')
          .is('.all')) {
          $('input[name=\'parentAll\']')
            .removeClass('all');
        }
        if (!$('input[name=\'parentAll\']')
          .is('.part')) {
          $('input[name=\'parentAll\']')
            .addClass('part');
        }
        $('input[name=\'parentAll\']')
          .prop('checked', true);
      } else {
        if ($('input[name=\'parentAll\']')
          .is('.all')) {
          $('input[name=\'parentAll\']')
            .removeClass('all');
        }
        if ($('input[name=\'parentAll\']')
          .is('.part')) {
          $('input[name=\'parentAll\']')
            .removeClass('part');
        }
        $('input[name=\'parentAll\']')
          .prop('checked', false);
      }

      // 二级全选按钮是否显示全部选中
      // $.each($('input[name$=\'childAll\']'), (index, item) => {
      //   const name = $(item)
      //     .attr('name')
      //     .substr(0, $(item)
      //       .attr('name').length - 3);
      //   const $subs = $(`input[name='${name}']`);
      //   // 部分子选项被选中
      //   if ($subs.length > $subs.filter(':checked').length > 0) {
      //     if ($(item)
      //       .is('.all')) {
      //       $(item)
      //         .removeClass('all');
      //     }
      //     if (!$(item)
      //       .is('.part')) {
      //       $(item)
      //         .addClass('part');
      //     }
      //     $(item)
      //       .prop('checked', true);
      //   }
      //   // 所有子选项被选中
      //   if ($subs.length <= $subs.filter(':checked').length) {
      //     if ($(item)
      //       .is('.part')) {
      //       $(item)
      //         .removeClass('part');
      //     }
      //     if (!$(item)
      //       .is('.all')) {
      //       $(item)
      //         .addClass('all');
      //     }
      //     $(item)
      //       .prop('checked', true);
      //   }
      //   // 没有子选项被选中
      //   if ($subs.filter(':checked').length <= 0) {
      //     if ($(item)
      //       .is('.part')) {
      //       $(item)
      //         .removeClass('part');
      //     }
      //     if ($(item)
      //       .is('.all')) {
      //       $(item)
      //         .removeClass('all');
      //     }
      //     $(item)
      //       .prop('checked', false);
      //   }
      // });

      // 公路全选按钮是否显示全部选中
      const high = $('input[terms="high"]').length;
      const highCheck = $('input[terms="high"]:checked').length;
      if (highCheck >= high) {
        $('input[terms=\'highCheck\']')
          .prop('checked', true);
        if ($('input[terms=\'highCheck\']')
          .is('.part')) {
          $('input[terms=\'highCheck\']')
            .removeClass('part');
        }
        if (!$('input[terms=\'highCheck\']')
          .is('.all')) {
          $('input[terms=\'highCheck\']')
            .addClass('all');
        }
      } else if (highCheck > 0) {
        $('input[terms=\'highCheck\']')
          .prop('checked', true);
        if ($('input[terms=\'highCheck\']')
          .is('.all')) {
          $('input[terms=\'highCheck\']')
            .removeClass('all');
        }
        if (!$('input[terms=\'highCheck\']')
          .is('.part')) {
          $('input[terms=\'highCheck\']')
            .addClass('part');
        }
      } else {
        $('input[terms=\'highCheck\']')
          .prop('checked', false);
        if ($('input[terms=\'highCheck\']')
          .is('.all')) {
          $('input[terms=\'highCheck\']')
            .removeClass('all');
        }
        if ($('input[terms=\'highCheck\']')
          .is('.part')) {
          $('input[terms=\'highCheck\']')
            .removeClass('part');
        }
      }

      // 水路全选按钮是否显示全部选中
      const water = $('input[terms="water"]').length;
      const waterCheck = $('input[terms="water"]:checked').length;
      if (waterCheck >= water) {
        $('input[terms=\'waterCheck\']')
          .prop('checked', true);
        if ($('input[terms=\'waterCheck\']')
          .is('.part')) {
          $('input[terms=\'waterCheck\']')
            .removeClass('part');
        }
        if (!$('input[terms=\'waterCheck\']')
          .is('.all')) {
          $('input[terms=\'waterCheck\']')
            .addClass('all');
        }
      } else if (waterCheck > 0) {
        $('input[terms=\'waterCheck\']')
          .prop('checked', true);
        if ($('input[terms=\'waterCheck\']')
          .is('.all')) {
          $('input[terms=\'waterCheck\']')
            .removeClass('all');
        }
        if (!$('input[terms=\'waterCheck\']')
          .is('.part')) {
          $('input[terms=\'waterCheck\']')
            .addClass('part');
        }
      } else {
        $('input[terms=\'waterCheck\']')
          .prop('checked', false);
        if ($('input[terms=\'waterCheck\']')
          .is('.part')) {
          $('input[terms=\'waterCheck\']')
            .removeClass('part');
        }
        if ($('input[terms=\'waterCheck\']')
          .is('.all')) {
          $('input[terms=\'waterCheck\']')
            .removeClass('all');
        }
      }

      // 水陆联运全选按钮是否显示全部选中
      const ally = $('input[terms="ally"]').length;
      const allyCheck = $('input[terms="ally"]:checked').length;
      if (allyCheck >= ally) {
        $('input[terms=\'allyCheck\']')
          .prop('checked', true);
        if ($('input[terms=\'allyCheck\']')
          .is('.part')) {
          $('input[terms=\'allyCheck\']')
            .removeClass('part');
        }
        if (!$('input[terms=\'allyCheck\']')
          .is('.all')) {
          $('input[terms=\'allyCheck\']')
            .addClass('all');
        }
      } else if (allyCheck > 0) {
        $('input[terms=\'allyCheck\']')
          .prop('checked', true);
        if ($('input[terms=\'allyCheck\']')
          .is('.all')) {
          $('input[terms=\'allyCheck\']')
            .removeClass('all');
        }
        if (!$('input[terms=\'allyCheck\']')
          .is('.part')) {
          $('input[terms=\'allyCheck\']')
            .addClass('part');
        }
      } else {
        $('input[terms=\'allyCheck\']')
          .prop('checked', false);
        if ($('input[terms=\'allyCheck\']')
          .is('.all')) {
          $('input[terms=\'allyCheck\']')
            .removeClass('all');
        }
        if ($('input[terms=\'allyCheck\']')
          .is('.part')) {
          $('input[terms=\'allyCheck\']')
            .removeClass('part');
        }
      }
    },

    // 默认选中
    defaultSelect(list, data) {
      const that = this;
      if (list && list.length > 0) {
        $.each(list, (index, item) => {
          $.each(data, (ind, tem) => {
            if (item.id == tem.id) {
              $(`input[dataId="${tem.id}"]`)
                .trigger('click');
              $(`input[dataId="${tem.id}"]`)
                .addClass('all');
            }
            // if ((!tem[that.childFiled] || tem[that.childFiled].length == 0) && item.id == tem.id) {
            //   $(`input[dataId="${tem.id}"]`)
            //     .trigger('click');
            //   $(`input[dataId="${tem.id}"]`)
            //     .addClass('all');
            // }
            // if (tem[that.childFiled] && tem[that.childFiled].length > 0) {
            //   $.each(tem[that.childFiled], (index1, tem1) => {
            //     if (item.id == tem1.id) {
            //       $(`input[dataId="${tem1.id}"]`)
            //         .trigger('click');
            //       $(`input[dataId="${tem1.id}"]`)
            //         .addClass('all');
            //     }
            //   });
            // }
          });
        });
        this.showAllCheck(list);
      }
    },

    // 运输条款选择
    shipTerms() {
      const that = this;
      // 公路全选
      if ($('input[terms="high"]').length > 0) {
        $('input[terms="highCheck"]')
          .parent()
          .css('display', 'inline-block');
        $('input[terms="highCheck"]')
          .on('click', function () {
            // 选中/取消所有子选项
            $('input[terms="high"]')
              .prop('checked', this.checked);
            if ($(this)
              .is(':checked')) {
              // if($(this).is('.all')) { $(this).removeClass('all'); }
              // if(!$(this).is('.part')) { $(this).addClass('part'); }
              if ($(this)
                .is('.part')) {
                $(this)
                  .removeClass('part');
              }
              if (!$(this)
                .is('.all')) {
                $(this)
                  .addClass('all');
              }
              // 选中所有子选项
              $('input[terms="high"]')
                .addClass('all');
            } else {
              if ($(this)
                .is('.part')) {
                $(this)
                  .removeClass('part');
              }
              if ($(this)
                .is('.all')) {
                $(this)
                  .removeClass('all');
              }
              // 取消所有子选项
              $('input[terms="high"]')
                .removeClass('all');
            }
            that.showAllCheck();
            that.checkList = that.getCheck();
          });
      } else {
        $('input[terms="highCheck"]')
          .parent()
          .css('display', 'none');
      }

      // 水路全选
      if ($('input[terms="water"]').length > 0) {
        $('input[terms="waterCheck"]')
          .parent()
          .css('display', 'inline-block');
        $('input[terms="waterCheck"]')
          .on('click', function () {
            // 选中/取消所有子选项
            $('input[terms="water"]')
              .prop('checked', this.checked);
            if ($(this)
              .is(':checked')) {
              // if($(this).is('.all')) { $(this).removeClass('all'); }
              // if(!$(this).is('.part')) { $(this).addClass('part'); }
              if ($(this)
                .is('.part')) {
                $(this)
                  .removeClass('part');
              }
              if (!$(this)
                .is('.all')) {
                $(this)
                  .addClass('all');
              }
              // 选中/取消所有子选项
              $('input[terms="water"]')
                .addClass('all');
            } else {
              if ($(this)
                .is('.part')) {
                $(this)
                  .removeClass('part');
              }
              if ($(this)
                .is('.all')) {
                $(this)
                  .removeClass('all');
              }
              // 取消所有子选项
              $('input[terms="water"]')
                .removeClass('all');
            }
            that.showAllCheck();
            that.checkList = that.getCheck();
          });
      } else {
        $('input[terms="waterCheck"]')
          .parent()
          .css('display', 'none');
      }

      // 水陆联运全选
      if ($('input[terms="ally"]').length > 0) {
        $('input[terms="allyCheck"]')
          .parent()
          .css('display', 'inline-block');
        $('input[terms="allyCheck"]')
          .on('click', function () {
            // 选中/取消所有子选项
            $('input[terms="ally"]')
              .prop('checked', this.checked);
            if ($(this)
              .is(':checked')) {
              // if($(this).is('.all')) { $(this).removeClass('all'); }
              // if(!$(this).is('.part')) { $(this).addClass('part'); }
              if ($(this)
                .is('.part')) {
                $(this)
                  .removeClass('part');
              }
              if (!$(this)
                .is('.all')) {
                $(this)
                  .addClass('all');
              }
              // 选中所有子选项
              $('input[terms="ally"]')
                .addClass('all');
            } else {
              if ($(this)
                .is('.part')) {
                $(this)
                  .removeClass('part');
              }
              if ($(this)
                .is('.all')) {
                $(this)
                  .removeClass('all');
              }
              // 取消所有子选项
              $('input[terms="ally"]')
                .removeClass('all');
            }
            that.showAllCheck();
            that.checkList = that.getCheck();
          });
      } else {
        $('input[terms="allyCheck"]')
          .parent()
          .css('display', 'none');
      }
    },

    // 数组去重
    uniqueFunc(arr, uniId) {
      const res = new Map();
      return arr.filter(item => !res.has(item[uniId]) && res.set(item[uniId], 1));
    },

    // 获取选中的input
    getCheck() {
      const that = this;
      const tempList = [];
      const list = this.checkList;
      $('input[name=\'parent\']:not(:disabled):checked')
        .each(function () {
          tempList.push($(this));
        });
      // $('input[name$=\'child\']:not(:disabled):checked')
      //   .each(function () {
      //     tempList.push($(this));
      //   });
      const indexList = [];
      $.each(list, (index, item) => {
        that.dataOne.some((tem) => {
          if (tem.id == item.id) {
            indexList.push(index);
          }
          // if ((!tem[that.childFiled] || tem[that.childFiled].length == 0) && tem.id == item.id) {
          //   indexList.push(index);
          // }
          // if (tem[that.childFiled] && tem[that.childFiled].length > 0) {
          //   $.each(tem[that.childFiled], (index1, tem1) => {
          //     if (item.id == tem1.id) {
          //       indexList.push(index);
          //     }
          //   });
          // }
        });
      });
      indexList.sort();
      if (indexList.length > 0) {
        for (let i = indexList.length - 1; i >= 0; i--) {
          list.splice(indexList[i], 1);
        }
      }
      $.each(tempList, (index, item) => {
        const id = $(item)
          .attr('dataId');
        if ($(item)
          .attr('name') == 'parent') {
          $.each(that.dataOne, (ind, tem) => {
            if (id == tem.id) {
              list.push(tem);
            }
          });
        }
        // else {
        //   const idex = $(item)
        //     .attr('name')
        //     .substring(0, $(item)
        //       .attr('name').length - 5);
        //   $.each(that.dataOne, (ind, tem) => {
        //     if (ind == idex) {
        //       $.each(tem[that.childFiled], (ind, ite) => {
        //         if (ite.id == id) {
        //           list.push(ite);
        //         }
        //       });
        //     }
        //   });
        // }
      });
      return this.uniqueFunc(list, 'id');
    },

    // 展开行数据
    unfoldRow(event) {
      const parent = $(event.currentTarget)
        .parent();
      const len = parent.siblings(`.child-${parent.attr('id')}`).length;
      parent.siblings(`.child-${parent.attr('id')}`)
        .toggle();
      if (parent.is('.show') && len > 0) {
        parent.removeClass('show');
      } else if (len > 0) {
        parent.addClass('show');
      }
    },

    // 批量导入
    planOnSuccess(res) {
      this.uploadDis = false;
      // if (res.status !== 0) return this.$message.error(res.message);
      // this.$message.success(res.message);
      // this.$parent.importStatement();
      this.$alert(res.message, '提示', {
        confirmButtonText: '关闭',
        callback: async () => {
        },
      });
    },
    beforeUpload(file) {
      this.uploadDis = true;
      const len = file.name.split('.').length;
      if (file.name.split('.')[len - 1] == 'xls' || file.name.split('.')[len - 1] == 'xlsx') {
        this.uploadData.mFile = file.name;
      } else {
        this.uploadDis = false;
        this.$message.error('请选择excel文件导入！！！');
        return false;
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      // this.message = '';
      this.$emit('getList');
    },
    uploadHttp(content) {
      let formData = new FormData();
      formData.append('file', content.file, content.file.name);
      console.log(content);
      console.log(formData);
      let that = this;
      this.$parent.importLoading = true;
      this.$axios({
        method: 'post',
        url: content.action + '&type=1',
        timeout: 600 * 1000,
        data: formData,
        headers: { 'content-type': 'multipart/form-data' },
      })
        .then(res => {
          this.uploadDis = false;
          this.$parent.importLoading = false;
          this.message = res.data.message;
          this.dialogVisible = true;
        })
        .catch(error => {
          if (error.response) {
            that.$message.error('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
            console.log('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
          } else if (error.request) {
            that.$message.error('配时文件上传失败，服务器端无响应');
            console.log('配时文件上传失败，服务器端无响应');
          } else {
            that.$message.error('配时文件上传失败，请求封装失败');
            console.log('配时文件上传失败，请求封装失败');
          }
          this.uploadDis = false;
        });
    },

    // 导入生成对账单
    importStatement() {
      // if (this.popoverheCkList.length < 3) return this.$message.warning("至少选择三个条件")
      this.$parent.importStatement();
    },
    // 导出数据
    exportData() {
      this.$emit('exportData');
    },

    // 台账月改变事件
    async taiCHange(index) {
      const obj = {
        id: this.data[index].id || '',
        standingBookMonth: this.data[index].standingBookMonth || '',
      };
      const res = await shippingBookMonth(obj);
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.$parent.shippingfeesettlement();
    },
    download() {
      window.location.href = '/file/委托商托运费导入模板.xlsx';
    },
    downloadOil() {
      window.location.href = '/file/油价联动模板.xlsx';
    },
  },
  watch: {
    checkList(newVal) {
      this.$emit('checkChange', newVal)
    },
    childFiled(newVal) {
      this.childName = [{ [newVal]: [] }];
    },
    dataOne: {
      handler(newVal) {
        $('input[name=\'parentAll\']')
          .prop('checked', false)
        $('input[terms=\'highCheck\']')
          .prop('checked', false);
        $('input[terms=\'waterCheck\']')
          .prop('checked', false);
        $('input[terms=\'allyCheck\']')
          .prop('checked', false);
        if (newVal.length > 0) {
          this.data = newVal;
          this.$nextTick(function () {
            this.allTrSelect(this.data);
            this.defaultSelect();
          });
        }
      },
      deep: true,
    },
    'field.loadTable': function () {
      this.$forceUpdate();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang='scss' scoped>
.check-table {
  display: block;
  width: 100%;
  color: #3b3b3b;
  font-size: 13px;
  text-align: center;
  line-height: 23px;
  background-color: rgba(0, 0, 0, 0);

  /* 复选框样式 */
  input[type='checkbox'] {
    position: relative;
    width: 14px;
    height: 14px;
    background-color: #fff;
    -webkit-appearance: none;
    border: 1px solid #dcdfe6;
    border-radius: 2px;
    outline: none;
    vertical-align: text-bottom;
    margin: 0px;
    margin-right: 2px;
  }

  input[type='checkbox']:hover {
    border: 1px solid #409eff;
  }

  input[type='checkbox']:checked {
    color: #fff;
    border-radius: 2px;
    border: 1px solid #409eff;
    background-color: #409eff;
  }

  /* 禁用样式 */
  input[type='checkbox']:disabled {
    background-color: #edf2fc;
    border-color: #DCDFE6;
    cursor: not-allowed;
  }

  /* 全部选中样式 */
  .all:checked::before {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    content: "";
    border: 1px solid #FFF;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    -webkit-transform: rotate(45deg) scaleY(1);
    transform: rotate(45deg) scaleY(1);
    width: 3px;
    -webkit-transform-origin: center;
    transform-origin: center;
  }

  /* 部分选中样式 */
  .part:checked::before {
    content: '';
    position: absolute;
    display: block;
    background-color: #FFF;
    height: 2px;
    -webkit-transform: scale(.5);
    transform: scale(.5);
    left: 0;
    right: 0;
    top: 5px;
  }

  .table {
    display: block;
    width: 100%;
    margin-bottom: 15px;
    overflow-x: auto;
    background-color: #fff;

    .parent {
      cursor: pointer;
    }

    table {
      table-layout: fixed;
      background-color: #ebeef5;

      td.null-child::before {
        font-size: 18px;
        color: #7f7f7f;
      }

      td.null-child::before {
        content: "─";
      }

      th.null-child::before {
        content: "";
      }

      thead {
        font-size: 13px;
        font-weight: bold;
        line-height: 35px;
        background-color: #e8e8e8;

        th {
          font-size: 13px;
          font-weight: bold;
          line-height: 23px;
          padding: 8px 0px !important;
          background-color: #e8e8e8;
        }
      }

      tbody {
        tr {
          border: none;
        }

        tr.show {
          display: table-row;
        }

        tr.total {
          border: 1px solid #ebeef5;
          line-height: 30px;
          font-size: 16px;
          font-weight: bold;
        }

        td {
          border: none;
          line-height: 23px;
          padding: 5px;
          background-color: #fff;
        }

        td>span {
          display: inline-block;
          width: 100%;
          text-align: left;
        }

        .parent td:nth-child(2)::before {
          display: inline-block;
          color: #7f7f7f;
          transform: rotate(180deg);
          transition: all .25s;
          -webkit-transition: all .25s;
        }

        .show td:nth-child(2)::before {
          display: inline-block;
          transform: rotate(270deg);
          transition: all .25s;
          -webkit-transition: all .25s;
        }
      }

      .child {
        display: none;
        border-bottom: none;
        transition: all .25s;
        -webkit-transition: all .25s;
      }

      .child>td {
        padding: 0px !important;
      }

      .child table {
        float: right;
      }

      .null::before {
        content: '';
      }

      .checkbox-th {
        min-width: 60px;
        font-size: 12px;
        font-weight: 700;
        color: #7f7f7f;
      }
    }
  }

}

.terms {
  display: block;
  width: 100%;
  text-align: left;
  font-size: 0px;
  margin-bottom: 10px;
  overflow: hidden;

  .termsLeft {
    float: left;
    min-width: 300px;
    vertical-align: top;

    input[type="checkbox"] {
      margin: 0px 10px 0px 0px !important;
    }

    span {
      display: inline-block;
      color: #727070;
      font-size: 13px;
      padding-right: 30px;
      vertical-align: top;
    }
  }

  .termsRight {
    float: right;
    min-width: 200px;
    font-size: 14px;
    color: #3388ff;
    vertical-align: top;
    text-align: right;

    // padding-right: 20px;
    span {
      padding: 0 5px;
    }
  }
}
</style>
